class AudioController {
    
    constructor (audioConfig) {
        
        this.storageId = "audio"
        this.config = audioConfig;
        this.channels = [];
        this.currentChannel = null;
        this._muted =  this.user_audio_muted_preference;
        this.mutedByUser =  this.user_audio_muted_preference;
        this.radio = null;
    }


    get user_audio_muted_preference () {

        if(!app.localStore.has(this.storageId)) {
            app.localStore.set(this.storageId, {muted: false});
        }


        return app.localStore.get(this.storageId).muted;
    }


    updateUserPreferences() {
        app.localStore.set(this.storageId, {muted: this.mutedByUser});
    }


    initialize (app) {




        this.radio = app.radio;
        app.radio.$on("router-change", ({ to }) => {
            this.onRouteChanged(to.path);
        })

        this.config.settings.channels.forEach(c => {
            this.channels.push(this.createAudioChannel(c.id, c.audio, c.routes, app));
        })

        this.onRouteChanged(app.vm.$route.path)

        // window.addEventListener("click", () => {
        //     if(this.muteAudioOnThisRoute(app.vm.$route.path)) 
        //         return;

    

        //     this.currentChannel && this.currentChannel.play();
        // })

        app.radio.$on("component-open", (componentId) => {this.onComponentOpen(componentId)});
        app.radio.$on("component-close", (componentId)=> {this.onComponentClose(componentId)});
        
        // TODO: if a user has muted it we cannot start playing.
        app.radio.$on("component-media-start", () => { this.mute(true) })
        app.radio.$on("component-media-ended", () => { this.mute(false) })

        app.radio.$on("audio-controller-global-mute-true", ()=> { 
            this.onMutedByUser();
        })
        app.radio.$on("audio-controller-global-mute-false", ()=> { 
            this.onPlayByUser();
        })


    // setTimeout(()=> {

    //     if(this.user_audio_muted_preference) 
    //     this.mute(true);
    // }, 1000)
   
    }

    createAudioChannel (id, sounds, routes, app) {
        return {
            id, 
            routes: routes.map(r => r.replace(/\{root\}/, app.router.defaultRoute)),
            channel: new AudioChannel(id, sounds, app.audio)
        };
    }

    getChannel (id) {
        return this.channels.find(c => c.id === id).channel;
    }


    onMutedByUser () {
        console.log("onMuteByUser")
        this.mutedByUser = true; 
        this.mute(true)
        this.updateUserPreferences();
    }
    onPlayByUser () {
        console.log("onPlayByUser")
        this.mutedByUser = false; 
        this.mute(false)
        this.updateUserPreferences();
    }

    
    mute (value) {

        
        console.log("mute recived", value, "mutedByUser", this.mutedByUser)

        
        if(this.mutedByUser) {
            this.currentChannel && this.currentChannel.mute(true, 500);
            return 
        }

        this.currentChannel && this.currentChannel.mute(value, 500);
        this.muted = value;
    }

    set muted (value) {
        console.log("set muted")
        this._muted = value;
        value ? this.radio.$emit("audio-controller-muted-true") : this.radio.$emit("audio-controller-muted-false");
    }

    get muted () {
        console.log("get muted")
        return this._muted;
    }
    
    onRouteChanged (to) {

        if(this.muteAudioOnThisRoute(to)) {
            return;
        }
        

        const route = to.replace(/:.*/, "");
        this.channels.forEach(c => {
            const channel = this.getChannel(c.id);
            if(c.routes.includes(route)) {
                this.currentChannel = channel;
                channel.play();
                
                if(this.user_audio_muted_preference) {

                    channel.mute(true);
                }
                else {

                    channel.fadeIn(500);
                }

            }
            else {
               channel.fade(0, 500, ()=> {
                   channel.stop();
               })
            }
        })
    }


    muteAudioOnThisRoute (route) {
        return route.split(":").splice(1).some(componentID => this.muteAudioWhileComponentIsOpen(componentID))
    }
    muteAudioWhileComponentIsOpen(componentId) {
        const componentType = touchKit.PageManager.getContent(componentId).type;
        return this.config.settings.stopWhenOpening.some(type => type === componentType);
    }

    onComponentOpen (componentId) {
        if(this.muteAudioWhileComponentIsOpen(componentId)) {
            this.mute(true)
        }
    }

    onComponentClose (componentId) {
        this.mute(false);
    }

}